module.exports = "../study/imgs/maps/Kanagawa/S8/WaterEnvironment/Chlave/Kanagawa_Chlave_MRI_RCP45_Now.png";